// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   ContactHero — /contact page hero
   Inherits hero__rail, hero__line from Hero.css via shared classes
   ============================================================ */

.cthero {
  position: relative;
  /* Not full screen — contact form follows immediately below */
  height: clamp(480px, 68vh, 780px);
  background: var(--c-cream);
  overflow: hidden;
  isolation: isolate;
}

/* Background media */
.cthero__media {
  position: absolute;
  inset: 0;
  mix-blend-mode: multiply;
  z-index: -1;
}

.cthero__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 65% center;
}

/* Cream scrim — fade left so text reads, let mountain show right */
.cthero__scrim {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      100deg,
      var(--c-cream) 0%,
      var(--c-cream) 28%,
      rgba(244, 239, 230, 0.82) 44%,
      rgba(244, 239, 230, 0.2) 62%,
      rgba(244, 239, 230, 0) 78%
    ),
    linear-gradient(
      to top,
      rgba(27, 27, 27, 0.16) 0%,
      rgba(27, 27, 27, 0) 38%
    );
}

/* Badge position */
.cthero__badge-pos {
  top: clamp(5rem, 10vh, 9rem);
  right: clamp(2rem, 8vw, 8rem);
  z-index: 4;
}

/* Layout shell */
.cthero__inner {
  position: relative;
  height: 100%;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: clamp(1rem, 2.5vw, 2.25rem);
  padding-top: 64px;
  z-index: 3;
}

/* Content column */
.cthero__content {
  max-width: 44rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: clamp(0.85rem, 1.5vw, 1.2rem);
}

/* Eyebrow */
.cthero__eyebrow {
  color: var(--accent) !important;
  letter-spacing: 0.24em;
}

/* Headline — forest green, very large */
.cthero__title {
  color: var(--c-forest);
  font-size: clamp(4rem, 11vw, 10rem);
  line-height: 0.88;
  margin: 0;
}

/* Short rust rule */
.cthero__rule {
  display: block;
  width: clamp(2.5rem, 4vw, 3.5rem);
  height: 3px;
  background: var(--accent);
  flex-shrink: 0;
  margin-block: 0.2rem;
}

/* Body copy */
.cthero__sub {
  font-family: var(--font-body);
  font-size: clamp(0.9rem, 1.2vw, 1.05rem);
  color: var(--c-ink);
  line-height: 1.72;
  max-width: 30rem;
  margin: 0;
}

/* Responsive */
@media (max-width: 991.98px) {
  .cthero__img { object-position: 60% center; }
  .cthero__scrim {
    background:
      linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 32%, rgba(244,239,230,0.88) 52%, rgba(244,239,230,0.3) 72%, rgba(244,239,230,0.05) 100%),
      linear-gradient(to top, rgba(27,27,27,0.2) 0%, rgba(27,27,27,0) 44%);
  }
  .cthero__badge-pos { display: none; }
}

@media (max-width: 767.98px) {
  .cthero {
    height: clamp(420px, 80vw, 580px);
  }
  .cthero__inner {
    grid-template-columns: 1fr;
    padding-inline: var(--gutter);
  }
  .cthero__rail { display: none; }
  .cthero__content { max-width: 100%; padding-bottom: 0; }
  .cthero__title { font-size: clamp(3.5rem, 14vw, 6rem); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactHero.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;;;;;;;;;KAaG;AACL;;AAEA,mBAAmB;AACnB;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;EACjB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA,YAAY;AACZ;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,mCAAmC;EACnC,iBAAiB;EACjB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,iCAAiC;EACjC,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,eAAe,2BAA2B,EAAE;EAC5C;IACE;;0EAEsE;EACxE;EACA,qBAAqB,aAAa,EAAE;AACtC;;AAEA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA,gBAAgB,aAAa,EAAE;EAC/B,mBAAmB,eAAe,EAAE,iBAAiB,EAAE;EACvD,iBAAiB,oCAAoC,EAAE;AACzD","sourcesContent":["/* ============================================================\n   ContactHero — /contact page hero\n   Inherits hero__rail, hero__line from Hero.css via shared classes\n   ============================================================ */\n\n.cthero {\n  position: relative;\n  /* Not full screen — contact form follows immediately below */\n  height: clamp(480px, 68vh, 780px);\n  background: var(--c-cream);\n  overflow: hidden;\n  isolation: isolate;\n}\n\n/* Background media */\n.cthero__media {\n  position: absolute;\n  inset: 0;\n  mix-blend-mode: multiply;\n  z-index: -1;\n}\n\n.cthero__img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 65% center;\n}\n\n/* Cream scrim — fade left so text reads, let mountain show right */\n.cthero__scrim {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(\n      100deg,\n      var(--c-cream) 0%,\n      var(--c-cream) 28%,\n      rgba(244, 239, 230, 0.82) 44%,\n      rgba(244, 239, 230, 0.2) 62%,\n      rgba(244, 239, 230, 0) 78%\n    ),\n    linear-gradient(\n      to top,\n      rgba(27, 27, 27, 0.16) 0%,\n      rgba(27, 27, 27, 0) 38%\n    );\n}\n\n/* Badge position */\n.cthero__badge-pos {\n  top: clamp(5rem, 10vh, 9rem);\n  right: clamp(2rem, 8vw, 8rem);\n  z-index: 4;\n}\n\n/* Layout shell */\n.cthero__inner {\n  position: relative;\n  height: 100%;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  column-gap: clamp(1rem, 2.5vw, 2.25rem);\n  padding-top: 64px;\n  z-index: 3;\n}\n\n/* Content column */\n.cthero__content {\n  max-width: 44rem;\n  padding-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: clamp(0.85rem, 1.5vw, 1.2rem);\n}\n\n/* Eyebrow */\n.cthero__eyebrow {\n  color: var(--accent) !important;\n  letter-spacing: 0.24em;\n}\n\n/* Headline — forest green, very large */\n.cthero__title {\n  color: var(--c-forest);\n  font-size: clamp(4rem, 11vw, 10rem);\n  line-height: 0.88;\n  margin: 0;\n}\n\n/* Short rust rule */\n.cthero__rule {\n  display: block;\n  width: clamp(2.5rem, 4vw, 3.5rem);\n  height: 3px;\n  background: var(--accent);\n  flex-shrink: 0;\n  margin-block: 0.2rem;\n}\n\n/* Body copy */\n.cthero__sub {\n  font-family: var(--font-body);\n  font-size: clamp(0.9rem, 1.2vw, 1.05rem);\n  color: var(--c-ink);\n  line-height: 1.72;\n  max-width: 30rem;\n  margin: 0;\n}\n\n/* Responsive */\n@media (max-width: 991.98px) {\n  .cthero__img { object-position: 60% center; }\n  .cthero__scrim {\n    background:\n      linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 32%, rgba(244,239,230,0.88) 52%, rgba(244,239,230,0.3) 72%, rgba(244,239,230,0.05) 100%),\n      linear-gradient(to top, rgba(27,27,27,0.2) 0%, rgba(27,27,27,0) 44%);\n  }\n  .cthero__badge-pos { display: none; }\n}\n\n@media (max-width: 767.98px) {\n  .cthero {\n    height: clamp(420px, 80vw, 580px);\n  }\n  .cthero__inner {\n    grid-template-columns: 1fr;\n    padding-inline: var(--gutter);\n  }\n  .cthero__rail { display: none; }\n  .cthero__content { max-width: 100%; padding-bottom: 0; }\n  .cthero__title { font-size: clamp(3.5rem, 14vw, 6rem); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
